module.exports = __webpack_public_path__ + "static/img/bentian.1ae0f627.png";